export default "__VITE_ASSET__BT_2koI8__"